import { Injectable } from '@angular/core';
import { ActivityLogType } from '@core/configs';
import { TimeService } from '@core/services/common/time.service';
import "moment/locale/ja";
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'  
})
export class FieldActivityLogController {

  private positionGridSubject$ = new BehaviorSubject<any>(null);
  private changeTimeSubject$ = new BehaviorSubject<any>(null);
  private time:any = null;
  private changeRedLineSubject$ = new BehaviorSubject<any>(null);
  
  private changeHeaderWithSubject$ = new BehaviorSubject<any>(null);

  private config:any = null;
  private parentHeader:any = null;
  private widthHeader = 0
  private leftHeader = 0
  private interval:any = null;

  constructor(private timeService: TimeService) {
    setInterval(() => this.updateSize(), 100);
    this.timeService.getCurrentTimeStrSubject().subscribe((time: any) => {
      this.updatePostion();
    })
  }

  updateSize(){
    if(this.parentHeader) {
      const parent = this.parentHeader?.nativeElement;
      const parentRect = parent.getBoundingClientRect();

      if(this.widthHeader != parentRect.width || this.leftHeader != parentRect.left) {
        if(this.interval) clearInterval(this.interval);

        this.widthHeader = parentRect.width;
        this.leftHeader = parentRect.left;
        this.interval = setTimeout(() => {
          this.changeHeaderWithSubject$.next(this.widthHeader);
        }, 200);
      }
    }
  }

  setParantHeander(parentRef: any) {
    this.parentHeader = parentRef;
  }
  getChangeSizeHeader() {
    return this.changeHeaderWithSubject$.asObservable();
  }
  getChangePositionGrid() {
    return this.positionGridSubject$.asObservable();
  }

  getChangeTime() {
    return this.changeTimeSubject$.asObservable();
  }

  getChangeRedLine() {
    return this.changeRedLineSubject$.asObservable();
  }
  
  getPosionReadLine (currentTime:any, config:any){ 
    if(config.type == ActivityLogType.LogCurrent) {
      let totlaTime = config.segmentNum *  config.interval;
      return 100 - (config.marginToTime ?? 0 ) * 100 / (totlaTime*60)
    }

    let startTimeShow = new Date(currentTime);
    startTimeShow.setHours(config.min);
    startTimeShow.setMinutes(0);
    startTimeShow.setSeconds(0);
    startTimeShow.setMilliseconds(0);
    let diffMs = currentTime.getTime() - startTimeShow.getTime();
    let diffMinutes = diffMs / (1000 * 60);

    return diffMinutes * 100/((config.max - config.min +1)*60);
  }


  getEndTime(currentTime:any, config:any){
    let current = currentTime;
    let endTimeShow = new Date(currentTime);

    let endhours = endTimeShow.getHours()
  
    endhours = (config.interval * (Math.floor((endhours +1)/ config.interval)) - 1) ;
    if( config.showOdd) endhours - 1;
    return endhours   
  }

  getPostionGrid(currentTime:any, config:any, endhours:any) {
    if(config.type == ActivityLogType.LogMaxMin) return 0;   
    let totlaTime = config.segmentNum *  config.interval;
    let current = currentTime;
    let endTimeShow = new Date(currentTime);
    endTimeShow.setHours(endhours);
    if(config.showEven) endTimeShow.setHours(endhours - 1);
    endTimeShow.setMinutes(0);
    endTimeShow.setSeconds(0);
    endTimeShow.setMilliseconds(0);
    let diffMs = current.getTime() - endTimeShow.getTime();
    let diffMinutes = diffMs / (1000 * 60);

    let potionEndHour = 100 - ( (config.marginToTime??0) + diffMinutes) * 100 / (totlaTime * 60)
    
    let potionGrid = potionEndHour - 100;

    return potionGrid;;
    
  }

  updatePostion() {
    if(this.config) {
      let postionRedLine = this.getPosionReadLine(this.timeService.getCurrentTime(), this.config);
      this.changeRedLineSubject$.next(postionRedLine);
      let endhours = this.getEndTime(this.timeService.getCurrentTime(), this.config)
      if(this.time != endhours){
        this.time = endhours;
        this.changeTimeSubject$.next(endhours)
      }
      let potionGrid = this.getPostionGrid(this.timeService.getCurrentTime(),  this.config, endhours);
      this.positionGridSubject$.next(potionGrid)
    };
  }
  
  setConfig(_config :any){
    this.config = _config;
    this.updatePostion();

  }
}
